<template>
  <div class="editor" :class="cls">
    <editor-menu-bar :editor="editor" v-slot="{ commands, isActive }">
      <div class="menubar">
        <button
          class="menubar__button"
          :class="{ 'is-active': isActive.bold() }"
          @click="commands.bold"
        >
          <div class="h6 mb-0">
            <b-icon icon="type-bold" variant="success"></b-icon>
          </div>
        </button>

        <button
          class="menubar__button"
          :class="{ 'is-active': isActive.italic() }"
          @click="commands.italic"
        >
          <div class="h6 mb-0">
            <b-icon icon="type-italic" variant="success"></b-icon>
          </div>
        </button>

        <button
          class="menubar__button"
          :class="{ 'is-active': isActive.strike() }"
          @click="commands.strike"
        >
          <div class="h6 mb-0">
            <b-icon icon="type-strikethrough" variant="success"></b-icon>
          </div>
        </button>

        <button
          class="menubar__button"
          :class="{ 'is-active': isActive.underline() }"
          @click="commands.underline"
        >
          <div class="h6 mb-0">
            <b-icon icon="type-underline" variant="success"></b-icon>
          </div>
        </button>

        <button
          class="menubar__button"
          :class="{ 'is-active': isActive.bullet_list() }"
          @click="commands.bullet_list"
        >
          <div class="h6 mb-0">
            <b-icon icon="list-ul" variant="success"></b-icon>
          </div>
        </button>

        <button
          class="menubar__button"
          :class="{ 'is-active': isActive.ordered_list() }"
          @click="commands.ordered_list"
        >
          <div class="h6 mb-0">
            <b-icon icon="list-ol" variant="success"></b-icon>
          </div>
        </button>

        <button
          class="menubar__button"
          :class="{ 'is-active': isActive.blockquote() }"
          @click="commands.blockquote"
        >
          <div class="h6 mb-0">
            <b-icon icon="blockquote-left" variant="success"></b-icon>
          </div>
        </button>

        <button
          class="menubar__button"
          :class="{ 'is-active': isActive.hlight({ flag: 1 }) }"
          @click="commands.hlight({ flag: 1 })"
        >
          <div class="h6 mb-0 btnhigh">PEN</div>
        </button>

        <button class="menubar__button" @click="commands.horizontal_rule">
          <div class="h6 mb-0">
            <div class="h6 mb-0 btnhigh">LINE</div>
          </div>
        </button>

        <button
          class="menubar__button"
          :class="{
            'is-active': isActive.alignnode({ textAlign: 'left' }),
          }"
          @click="commands.alignnode({ textAlign: 'left' })"
        >
          <div class="h6 mb-0">
            <div class="h6 mb-0 btnhigh">AL</div>
          </div>
        </button>

        <button
          class="menubar__button"
          :class="{
            'is-active': isActive.alignnode({ textAlign: 'center' }),
          }"
          @click="commands.alignnode({ textAlign: 'center' })"
        >
          <div class="h6 mb-0">
            <div class="h6 mb-0 btnhigh">AC</div>
          </div>
        </button>

        <button
          class="menubar__button"
          :class="{
            'is-active': isActive.alignnode({ textAlign: 'right' }),
          }"
          @click="commands.alignnode({ textAlign: 'right' })"
        >
          <div class="h6 mb-0">
            <div class="h6 mb-0 btnhigh">AR</div>
          </div>
        </button>
      </div>
    </editor-menu-bar>

    <editor-content class="editor__content" :editor="editor" />
  </div>
</template>

<script>
import Icon from "@/components/Icon";
import { Editor, EditorContent, EditorMenuBar } from "tiptap";
import Image from "./Image";
import HLight from "./HLight";
import AlignNode from "./AlignNode";
import AWS from "aws-sdk";
import {
  Blockquote,
  CodeBlock,
  HardBreak,
  Heading,
  HorizontalRule,
  OrderedList,
  BulletList,
  ListItem,
  TodoItem,
  TodoList,
  Bold,
  Code,
  Italic,
  Strike,
  Underline,
} from "tiptap-extensions";

function uuidv4() {
  return "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".replace(/[xy]/g, function (c) {
    var r = (Math.random() * 16) | 0,
      v = c == "x" ? r : (r & 0x3) | 0x8;
    return v.toString(16);
  });
}

async function upload(file) {
  AWS.config.update({
    region: "ap-northeast-2",
    credentials: new AWS.CognitoIdentityCredentials({
      IdentityPoolId: "ap-northeast-2:dc9b0c57-3ee5-47da-9239-931dcf6da667",
    }),
  });

  var s3 = new AWS.S3({
    apiVersion: "2006-03-01",
    params: { Bucket: "com.cedu.csd" },
  });

  let resp = await s3
    .upload({
      Key: uuidv4() + file.name,
      ContentType: "image/png",
      Body: file,
      ACL: "public-read",
    })
    .promise();

  return resp.Location;
}

export default {
  components: {
    EditorContent,
    EditorMenuBar,
  },
  props: ["content", "func", "cls"],
  data() {
    return {
      editor: new Editor({
        disablePasteRules: true, // disable Markdown when pasting
        disableInputRules: true, // disable Markdown when typing
        extensions: [
          new Blockquote(),
          new BulletList(),
          new CodeBlock(),
          new HardBreak(),
          new Heading({ levels: [1, 2, 3] }),
          new HorizontalRule(),
          new ListItem(),
          new OrderedList(),
          new TodoItem(),
          new TodoList(),
          new Bold(),
          new Code(),
          new Italic(),
          new Strike(),
          new Underline(),
          new HLight(),
          new Image(null, null, upload),
          new AlignNode(),
        ],
        content: this.content,
      }),
    };
  },

  watch: {
    content(to, from) {
      console.log("load content editor");
      //alert("watch");
      let $this = this;
      setTimeout(() => {
      console.log("load content editor2");
        $this.editor.setContent(to);
      }, 1500);
    },
  },

  beforeDestroy() {
    this.editor.destroy();
  },
  mounted() {
    console.log("mounted!!");
    let $this = this;
    this.editor.on("update", ({ getHTML }) => {
      $this.$store.commit($this.func, getHTML());
    });
  },
  methods: {
    reset() {
      console.log("reset");
      this.editor.setContent("");
    },
  },
};
</script>


<style lang="scss" scoped>
@import "@/styles/_variables.scss";
.editor {
  position: relative;
  border: 1px solid $gray200;
  border-radius: 5px;
  &__floating-menu {
    position: absolute;
    z-index: 1;
    margin-top: -0.25rem;
    visibility: hidden;
    opacity: 0;
    transition: opacity 0.2s, visibility 0.2s;
    &.is-active {
      opacity: 1;
      visibility: visible;
    }
  }
  .rdclass {
    // color: red;
    // border-bottom: 1px solid red;
    background: #ddd;
    border-radius: 4px;
    padding: 6px;
    font-size: 1em;
    font-weight: normal;
    margin-bottom: 1px;
  }
}
.readingWide {
  min-height: 250px;
}

.editor__content *.is-empty:nth-child(1)::before,
.editor__content *.is-empty:nth-child(2)::before {
  content: attr(data-empty-text);
  float: left;
  //   color: #c9cdd2;
  color: red;
  pointer-events: none;
  height: 0;
  font-style: italic;
}
.btnhigh {
  font-size: 0.8rem;
}
.flag1 {
  border: 2px solid red;
  padding: 2px;
}
</style>
